export default __webpack_public_path__ + "static/sv-c9cdd48dda005310fc02e6f73a5d8607.svg";